// extracted by mini-css-extract-plugin
export default {"rating":"PostRaiting_rating__7D39I","up":"PostRaiting_up__9DuCA","down":"PostRaiting_down__8oZF9"};